import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import { checkConditions } from '../HelperFunctions/checkConditions';
import Icon from 'components/Icons/Icon';

import './Accordion.scss'

function Accordion({ 
  conditions = [],
  title,
  disabled = false,
  content,
  accordionHeaderSection = false,
  accordionHeaderContents = {},
  showNumberInHeader= false,
  headerNumber="",
  dynamicHeaderState,
  openOnLoad = false,
  overflowVisible = false,
}) {

  const [showAccordion, setShowAccordion] = useState(openOnLoad);

  // selectors
  const darkMode = useSelector(state => state.app.darkMode);

  // custom conditions
  const conditionsOnHover = checkConditions(conditions);

  // state
  const [isHovered, setIsHovered] = useState(false);
  
  // functions
  const toggleAccordion = () => {
    setShowAccordion(!showAccordion);
  }
  const handleMouseEnter = () => {
    setIsHovered(false);
  }
  const handleMouseLeave = () => {
    setIsHovered(true);
  }

  // useEffect(() => {
  //   if (openOnLoad) {
  //     setTimeout(() => {
  //       setShowAccordion(true)
  //     }, 100);
  //   }
  // }, [openOnLoad])
  
  return (
    <div className={`accordion-wrapper w-100`}>
      <div
        className={`custom-card
          ${(!showAccordion || !isHovered ? 'accordion-hover' : '')} 
          ${!showAccordion ? showNumberInHeader ? 'add-padding pr-2' : 'add-padding' : 'remove-padding'} 
          ${darkMode ? "darkMode" : ""} 
          ${disabled ? "disabled" : ""} 
          w-100`
        }
        id={`${title}-accordion`}
        data-intercom-target={`${title}-accordion-container`}
        onClick={() => {
          if (!showAccordion) {
            toggleAccordion()
          }
        }}
      >
        <header className={`accordion-header-wrapper ${showNumberInHeader ? 'show-number-in-header' : ''} w-100`}>
          <div className={`
            w-100 d-flex justify-content-between align-items-center 
            ${showNumberInHeader ? showAccordion ? 'pl-4 pr-2' : 'pl-2 pr-0' : ''} 
            ${showAccordion && !accordionHeaderSection ? 'border-bottom' : ''}
          `}>

            {showNumberInHeader &&
              <div className={`number-in-header col-1 ${showAccordion ? 'mr-0' : 'mr-2'}`}>
                {headerNumber}
              </div>
            }
            <div
              className={
                `d-flex justify-content-between 
                accordion-card-header 
                ${showAccordion ? "accordion-card-header-after" : "accordion-card-header"}
                ${showNumberInHeader ? 'col' : ''}
                w-100
              `}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                if (showAccordion) {
                  toggleAccordion()
                }
              }}
            >
              <div className='d-flex justify-content-center align-items-center'>{title}</div>
              <Button onClick={toggleAccordion}>
                <Icon className={`fas ${showAccordion ? "fa-chevron-up" : "fa-chevron-down"} accordion-button`}></Icon>
              </Button>
            </div>

          </div>

          {/* Accordion Header Section */}
          {accordionHeaderSection && 
            <div className={`accordion-header-section ${showAccordion ? '-after' : ''} ${dynamicHeaderState ? 'header-height-transition' : ''}`}>
              <span 
                className={`
                  ${accordionHeaderContents?.size} 
                  ${accordionHeaderContents?.scrollEnabled ? 'content-scroll' : ''} 
                  ${accordionHeaderContents?.contentSize}
                `}
              >
                {accordionHeaderContents?.message}
              </span>
            </div>
          }

        </header>
        
        {/* Content */}
        <div className={`accordion-content ${showAccordion ? overflowVisible ? " -show -visible" : " -show" : ""}`}>
          {content}
        </div>

      </div>
    </div>
  )
}

export default Accordion
